<template>
  <v-select
    v-bind="$attrs"
    :items="items"
    :label="label"
    :prepend-icon="prependIcon"
    :value="value"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
  >
    <template #selection="{ item }">
      <note-severity-icon :severity="item.value" small />
      <span class="ml-2">{{ item.text }}</span>
    </template>

    <template #item="{ item }">
      <v-list-item-action>
        <note-severity-icon :severity="item.value" small />
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
import NoteSeverityIcon from './NoteSeverityIcon'

export default {
  name: 'NoteSeveritySelect',

  components: {
    NoteSeverityIcon
  },

  props: {
    value: {
      type: null,
      required: true
    },
    label: {
      type: String,
      default: 'Wichtigkeit'
    },
    prependIcon: {
      type: String,
      default: '$freshvuenotes-severity-icon'
    }
  },

  data() {
    const getText = (severity) =>
      this.$t(`fresh-vue-notes.severity.${severity}`)

    return {
      items: [
        { value: 'NONE', text: getText('NONE') },
        { value: 'INFO', text: getText('INFO') },
        { value: 'SUCCESS', text: getText('SUCCESS') },
        { value: 'WARNING', text: getText('WARNING') },
        { value: 'ERROR', text: getText('ERROR') }
      ]
    }
  }
}
</script>
